import React, { createContext, useContext, useState } from 'react'
import { getTheme, setTheme } from '../utils/theme'

// App-wide theme state. The active theme is stored on <body data-theme> (see
// utils/theme.js); this context lets any page/component re-render when it
// changes (e.g. the chart needs to re-read its colours).
const ThemeCtx = createContext({ theme: 'console', changeTheme: () => {} })

export const useThemeCtx = () => useContext(ThemeCtx)

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getTheme())
  const changeTheme = (t) => setThemeState(setTheme(t))
  return <ThemeCtx.Provider value={{ theme, changeTheme }}>{children}</ThemeCtx.Provider>
}
